(function () {
  'use strict';

  function formRadioButton () {
    return {
      'restrict': 'E',
      'templateUrl': 'components/shared/form-radio-button/form-radio-button.html',
      'scope': {
        'model': '=',
        'btnValue': '@',
        'btnLabel': '@'
      }
    };
  }

  angular.module('web2print.shared')
    .directive('formRadioButton', formRadioButton);
})();
